'use strict';
import $ from 'jquery';

export default class ListingResults {
	constructor($selector, selfInit = true) {
		this.$selector = $selector;

		if(selfInit) this.init();
	}

	init() {
		const params = new URLSearchParams(window.location.search);
		let searchTerm = params.get('q');

		if (searchTerm) {
			searchTerm = searchTerm.trim().toLowerCase();
			const regexTerm = new RegExp(searchTerm, 'ig');

			$('.search-listing-item', this.$selector).map((i,ele) => {
				const title = $('h3 > a', $(ele)).html();
				const teaser = $('p:not(.date)', $(ele)).html();
				let highlightedTitle, highlightedTeaser;

				if(title && title.toLowerCase().indexOf(searchTerm) > -1) {
					highlightedTitle = title.replace(regexTerm, `<span class="highlight">$&</span>`);
				}

				if(teaser && teaser.toLowerCase().indexOf(searchTerm) > -1) {
					highlightedTeaser = teaser.replace(regexTerm, `<span class="highlight">$&</span>`);
				}

				$('h3 > a', $(ele)).html(highlightedTitle);
				$('p:not(.date)', $(ele)).html(highlightedTeaser);
			});
		}
	}
}
